// @core/api/endpoints/product/list_dependent_products.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductDependenciesResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List products that depend on this product
 * Returns all products that have declared a dependency on this product. Useful for impact analysis when making changes to a product.
 * @public This endpoint does not require authentication
 */
export async function ListDependentProducts(
  product_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductDependenciesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/dependents`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductDependenciesResponse>(requestPath, { ...requestOptions, params });
}
